import React, { Component } from 'react';
import { DropdownMenu, DropdownToggle, DropdownItem, Nav } from 'reactstrap';
import PropTypes from 'prop-types';
import cookie from 'react-cookies'

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';

import logo from '../../assets/img/brand/logo.png'
// import logo from '../../assets/img/logo1.png'
import sygnet from '../../assets/img/brand/sygnet.svg'
import avatar from '../../assets/img/avatars/6.jpg'
import { destroySession } from '../../views/services'
import { UserContext } from '../../contexts';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  logoutUser = async () => {
    const response = await destroySession();
    cookie.remove("_mkdtoken", { maxAge :0, domain: process.env.REACT_APP_DOMAIN, path: '/' })
    window.location = process.env.REACT_APP_HOST;
  }

  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 100, height: 50, alt: 'Mom Kid Care' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'Mom Kid Care' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />
        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown>
            <DropdownToggle nav>
              <UserContext.Consumer>
                {(value) => <img src={`${process.env.REACT_APP_HOST}/${value}`} className="img-avatar" />}
              </UserContext.Consumer>
              {/* <img src={avatar} className="img-avatar" alt="admin@bootstrapmaster.com" /> */}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={this.logoutUser}>Sign out</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js